<div class="main">
  <div style="min-height: 50vh; width: 100vw" *ngIf="isLoadingFractures">
    <div class="loading-shade">
      <mat-spinner></mat-spinner>
    </div>
  </div>

  <div class="general-data">
    <table>
      <thead>
        <tr>
          <th>Wellbore</th>
          <th>Tope superior [m]</th>
          <th>Base Inferior [m]</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="hasIntervalBase || hasIntervalTop || hasWellboreId">
          <td class="td-data">
            <mat-label
              [ngClass]="{
                'label-visible': hasWellboreId,
                'label-no-visible': !hasWellboreId
              }"
            >
              {{ originalFracture.wellboreNo }}</mat-label
            >
          </td>
          <td class="td-data">
            <mat-label
              [ngClass]="{
                'label-visible': hasIntervalTop,
                'label-no-visible': !hasIntervalTop
              }"
            >
              {{ originalFracture.intervalTop | number : "1.2-2" }}</mat-label
            >
          </td>
          <td class="td-data">
            <mat-label
              [ngClass]="{
                'label-visible': hasIntervalBase,
                'label-no-visible': !hasIntervalBase
              }"
            >
              {{ originalFracture.intervalBase | number : "1.2-2" }}</mat-label
            >
          </td>
        </tr>
      </tbody>
    </table>
    <div
      *ngIf="!hasIntervalBase && !hasIntervalTop && !hasWellboreId"
      class="no-data"
    >
      <h3>No se encontraron datos</h3>
      <p>
        De existir datos en el sistema de<br />origen, podrás visualizarlos acá
      </p>
    </div>
  </div>

  <div class="fracture-table-wrapper" *ngIf="!isLoadingFractures">
    <table mat-table [dataSource]="fractures" class="perforation-table">
      <ng-container matColumnDef="reportDate">
        <mat-header-cell *matHeaderCellDef> Fecha </mat-header-cell>
        <mat-cell *matCellDef="let fracture">
          {{ fracture.reportDate | date : "dd/MM/yyyy" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="reportNo">
        <mat-header-cell *matHeaderCellDef> Etapa </mat-header-cell>
        <mat-cell *matCellDef="let fracture">
          {{ fracture.reportNo }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="intervalTop">
        <mat-header-cell *matHeaderCellDef>
          Tope <br />
          Intervalo [m]
        </mat-header-cell>
        <mat-cell *matCellDef="let fracture">
          {{ fracture.intervalTop | number : "1.2-2" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="intervalBase">
        <mat-header-cell *matHeaderCellDef>
          Base <br />
          Intervalo [m]
        </mat-header-cell>
        <mat-cell *matCellDef="let fracture">
          {{ fracture.intervalBase | number : "1.2-2" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="proppantUsed">
        <mat-header-cell *matHeaderCellDef>
          Arena <br />
          Mezclada [sk]
        </mat-header-cell>
        <mat-cell *matCellDef="let fracture">
          {{ fracture.proppantUsed }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="proppantInFormation">
        <mat-header-cell *matHeaderCellDef>
          Arena en <br />
          Formulacion [sk]
        </mat-header-cell>
        <mat-cell *matCellDef="let fracture">
          {{ fracture.proppantInFormation }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="propConcAverage">
        <mat-header-cell *matHeaderCellDef>
          Concentracion <br />
          avg. [ppg]
        </mat-header-cell>
        <mat-cell *matCellDef="let fracture">
          {{ fracture.propConcAverage | number : "1.2-2" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="injectrateaverage">
        <mat-header-cell *matHeaderCellDef>
          Caudal avg. <br />
          [bbl/min]
        </mat-header-cell>
        <mat-cell *matCellDef="let fracture">
          {{ fracture.injectrateaverage | number : "1.1-1" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="maxPressure">
        <mat-header-cell *matHeaderCellDef>
          Presion max. <br />
          [psi]
        </mat-header-cell>
        <mat-cell *matCellDef="let fracture">
          {{ fracture.maxPressure | number : "1.2-2" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="avgPressure">
        <mat-header-cell *matHeaderCellDef>
          Presion avg. <br />
          [psi]
        </mat-header-cell>
        <mat-cell *matCellDef="let fracture">
          {{ fracture.avgPressure | number : "1.2-2" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="instantPressure">
        <mat-header-cell *matHeaderCellDef>
          Presion de <br />
          cierre [psi]
        </mat-header-cell>
        <mat-cell *matCellDef="let fracture">
          {{ fracture.instantPressure | number : "1.2-2" }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="noData">
        <mat-footer-cell *matFooterCellDef colspan="4">
          <div class="footer">
            <div class="footer-no-data">No se encontraron datos.</div>
            <div class="footer-no-data-origin">
              De existir datos en el sistema de origen, podrás visualizarlos
              acá.
            </div>
          </div>
        </mat-footer-cell>
      </ng-container>

      <mat-header-row
        *matHeaderRowDef="displayedColumns; sticky: true"
      ></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      <mat-footer-row
        *matFooterRowDef="['noData']"
        [ngClass]="{ 'hide-footer': hideFooter }"
      ></mat-footer-row>
    </table>
  </div>
</div>
<app-handover-detail-fracture-stimulations
  [handoverId]="handoverId"
  [handoverStatusId]="handoverStatusId"
  [wellName]="wellName"
></app-handover-detail-fracture-stimulations>
<app-handover-detail-acidification-stimulations
  [handoverId]="handoverId"
  [handoverStatusId]="handoverStatusId"
  [wellName]="wellName"
></app-handover-detail-acidification-stimulations>
